import { render, staticRenderFns } from "./addCopyForItem.vue?vue&type=template&id=72a56e91&scoped=true&"
import script from "./addCopyForItem.vue?vue&type=script&lang=js&"
export * from "./addCopyForItem.vue?vue&type=script&lang=js&"
import style0 from "./addCopyForItem.vue?vue&type=style&index=0&id=72a56e91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a56e91",
  null
  
)

export default component.exports